import {
  Button,
  Heading,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
} from '@chakra-ui/react';
import { cloneElement, useCallback } from 'react';

interface ConfirmModalProps {
  heading?: string;
  children: React.ReactNode;
  text?: string;
  cancelButtonText?: string;
  okButtonText?: string;
  onOk: () => void;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  heading,
  text,
  cancelButtonText,
  okButtonText,
  onOk,
  children,
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const handleConfirm = useCallback(() => {
    onOk();
    onClose();
  }, [onOk, onClose]);

  return (
    <>
      {cloneElement(children as React.ReactElement<{ onClick?: () => void }>, {
        onClick: onOpen,
      })}
      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent
          bg="bg.brand"
          overflow="hidden"
          borderRadius={10}
          color="text.brand"
          width="390px"
        >
          <ModalCloseButton />
          <ModalHeader as={Heading} size="lg" fontWeight="normal" pb={0} mt={8}>
            {heading || 'Are you sure?'}
          </ModalHeader>
          {text && (
            <ModalBody position="relative">
              <Text as="p" size="sm">
                {text}
              </Text>
            </ModalBody>
          )}
          <ModalFooter gap="4">
            <Button
              variant="outline"
              // color="white"
              onClick={onClose}
            >
              {cancelButtonText || 'Cancel'}
            </Button>
            <Button
              // variant="outline"
              color="white"
              onClick={handleConfirm}
            >
              {okButtonText || 'Confirm'}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default ConfirmModal;
